<template>
  <div class="info">
    <div class="item1">
      <img class="item-img" src="../assets/img/logo.png" alt="logo" />
      <div class="item-t1">湖北大学</div>
      <div class="item-t2">
        <img
          class="item-img2"
          src="../assets/img/icon_address.png"
          alt="logo"
        /><span>湖北-武汉</span>
      </div>
      <div class="item-t3">{{ content1 }}</div>
      <div class="item-t4">
        <img class="item-banner" src="../assets/img/img03.png" alt="banner" />
      </div>
      <a class="show" @click="showFn"
        >{{ title1 }}<i :class="title1 == '展开全部' ? 'icon1' : 'icon2'"></i
      ></a>
    </div>
    <div class="item2">
      <div class="item2-t1">专业信息<i class="item2-i"></i></div>
      <div class="item-table">
        <dl class="dl-table">
          <dt class="dt">
            <span>项目分类</span>
            <span>层次</span>
            <span>专业名称</span>
            <span>专业代码</span>
          </dt>
          <dd class="dd">
            <span>自考</span>
            <span>专科</span>
            <span>教育管理</span>
            <span>1213145</span>
          </dd>
          <dd class="dd">
            <span>网教</span>
            <span>专升本</span>
            <span>环境与经济学基…</span>
            <span>15427414</span>
          </dd>
          <dd class="dd">
            <span>网教</span>
            <span>专升本</span>
            <span>心理学</span>
            <span>15427414</span>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'info',
  data() {
    return {
      list: [0],
      title1: '展开全部',
      content1:
        '湖北大学（Hubei University）坐落于湖北省武汉市，是湖北省人民政府与教育部共建的省属重点综合性大学，入选“中西部高校基础能力建设工程”，是湖北省“2011计划”牵头高校，武器装备科研设备…'
    };
  },
  methods: {
    showFn() {
      if (this.title1 == '展开全部') {
        this.title1 = '收起';
        this.content1 =
          '湖北大学（Hubei University）坐落于湖北省武汉市，是湖北省人民政府与教育部共建的省属重点综合性大学，入选“中西部高校基础能力建设工程”，是湖北省“2011计划”牵头高校，武器装备科研生产二级保密资格高校，中国政府奖学金来华留学生和港澳台学生接收高校，是教育部和英国大使馆批准设立的湖北省唯一的雅思（IELTS）考试考点单位。截至2017年10月，湖北大学有武昌主校区、汉口校区、阳逻校区等3个校区和1个大学科技园，总占地面积2100余亩。校舍总建筑面积71万平方米，资产总额25.12亿元，其中固定资产12.1亿元、教学科研仪器设备总值近3亿元。图书馆总面积4.73万平方米，馆藏纸质文';
      } else {
        this.title1 = '展开全部';
        this.content1 =
          '湖北大学（Hubei University）坐落于湖北省武汉市，是湖北省人民政府与教育部共建的省属重点综合性大学，入选“中西部高校基础能力建设工程”，是湖北省“2011计划”牵头高校，武器装备科研设备…';
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
// @import '@/assets/css/color.scss';
.info {
  height: 100%;
  background-color: #f8f8f8;
  font-size: 24px;
  color: #06112a;
}
.item1,
.item2 {
  background-color: #fff;
}
.item1 {
  min-height: 904px;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  padding-bottom: 32px;
}
.item-img {
  display: block;
  box-sizing: content-box;
  width: 160px;
  height: 160px;
  margin: 0 auto 22px;
  padding-top: 32px;
}
.item-t1 {
  width: 100%;
  text-align: center;
  height: 34px;
  font-size: 36px;
  font-weight: bold;
  color: #06112a;
  line-height: 34px;
}
.item-t2 {
  text-align: center;
  margin-top: 12px;
}
.item-t2 span {
  display: inline-block;
  height: 28px;
  padding-left: 5px;
}
.item2 {
  min-height: 492px;
  margin-top: 20px;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
}
.item-img2 {
  width: 30px;
  height: 30px;
  vertical-align: top;
}
.item-t3 {
  font-size: 28px;
  font-weight: 500;
  line-height: 42px;
  padding: 0 30px;
  margin-top: 22px;
}
.item-banner {
  display: block;
  width: 100%;
  height: 320px;
  border-radius: 24px;
}
.item-t4 {
  padding: 0 32px;
  margin-top: 20px;
}
.show {
  display: block;
  width: 200px;
  height: 60px;
  background-color: #f8f8f8;
  border-radius: 30px;
  color: #ff660f;
  font-size: 24px;
  line-height: 60px;
  text-align: center;
  margin: 24px auto 0;
  position: relative;
}
.icon1,
.icon2 {
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  display: block;
  position: absolute;
  right: 24px;
  top: 26px;
}
.icon1 {
  border-top: 8px solid #ff660f;
}
.icon2 {
  border-bottom: 8px solid #ff660f;
}
.item2-t1 {
  padding: 33px 30px 0;
  height: 65px;
  font-size: 30px;
  font-weight: bold;
  color: #06112a;
  line-height: 32px;
  position: relative;
}
.item2-i {
  display: block;
  content: '';
  height: 30px;
  width: 8px;
  position: absolute;
  left: 0;
  top: 32px;
  background: url('../assets/img/icon_line.png') left center no-repeat;
}
.item-table {
  margin-top: 26px;
  padding: 0 30px;
}
.dl-table {
  width: 100%;
  /* border: 1px solid #E9EDF1;  */
}
.dt,
.dd {
  display: flex;
  line-height: 80px;
  text-align: center;
}
.dt {
  height: 80px;
  background: #f8f8f8;
  border: 1px solid #f8f8f8;
  border-radius: 16px 16px 0px 0px;
}
.dd {
  height: 80px;
  background: #ffffff;
  border-left: 1px solid #e9edf1;
  border-right: 1px solid #e9edf1;
  border-bottom: 1px solid #e9edf1;
  /* margin-top:-1px; */
}
.dt span,
.dd span {
  display: block;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/view/info.vue